import { Injectable, inject } from '@angular/core';
import { LoggerService } from '@core/services/logger.service';
import { type MissingTranslationHandler, type MissingTranslationHandlerParams } from '@ngx-translate/core';

/**
 * Renders an unresolved key as `{{ key }}` instead of the bare key.
 */
@Injectable()
export class BracedMissingTranslationHandler implements MissingTranslationHandler {
  private readonly logger = inject(LoggerService);

  handle(params: MissingTranslationHandlerParams): string {
    this.logger.warn(
      `[i18n] Missing translation for key "${params.key}" in "${params.translateService.getCurrentLang()}".`
    );

    return `{{ ${params.key} }}`;
  }
}
